export function formatPrice(value: number): string {
    if (!value) {
        return '$' + Math.abs(0).toFixed(2);
    }
    return '$' + Math.abs(value).toFixed(2);
}

export function formatPeso(value: number): string {
    if (!value) {
        return '₱0';
    }
    return '₱' + Math.abs(value);
}
